<template>
    <div class="examine">
        <Box :title="PageNmae+'审批'">
            <div class="infoBox" v-if="Data.SPLX===('1'||'6')">
                <p class="title">申购信息</p>
                <Field title="申请单号" type='text' :text='Data.SQDH' />
                <Field title="申请科室" type='text' :text='Data.KSMC' />
                <Field title="设备名称" type='text' :text='Data.SBMC' />
                <Field title="设备别名" type='text' :text='Data.SBBM' />
                <Field title="规格型号" type='text' :text='Data.SBXH' />
                <Field title="单价" type='text' :text='Number(Data.CGDJ).toFixed(2)' />
                <Field title="申请数量" type='text' :text='parseInt(Data.CGSL)' />
                <Field title="单位" type='text' :text='Data.SBDW' />
                <Field title="申请时间" type='text' :text='Data.SQRQ' />
                <Field title="申请人" type='text' :text='Data.SQR' />

                <Field title="申请理由" type='textarea' :text='Data.SQYY' />
            </div>
            <div class="infoBox" v-else-if="Data.SPLX!==('1'||'6')">
                <p class="title">{{PageNmae}}信息</p>
                <Field title="申请单号" type='text' :text='Data.SQDH' />
                <Field title="资产编号" type='text' :text='Data.SBBH' />
                <Field title="资产名称" type='text' :text='Data.SBMC' />
                <Field title="申请人" type='text' :text="Data.SQR" />
                <div v-if="Data.SPLX==='4'">
                    <Field title="原科室" type='text' :text="ChangeDeparment.YKS" />
                    <Field title="现科室" type='text' :text='ChangeDeparment.XKS' />
                    <Field title="现科室负责人" type='text' :text="ChangeDeparment.XKSFZR||'暂无'" />
                </div>
                <div v-else-if="Data.SPLX!=='4'">
                    <Field title="使用科室" type='text' :text='Data.SBBM' />
                </div>
                <Field title="规格型号" type='text' :text='Data.SBXH' />
                <Field title="资产原值" type='text' :text='Data.HTJG' />
                <Field title="资产序列号" type='text' :text='Data.SBXLH' />
                <Field title="启用日期" type='text' :text='Data.QYRQ' />
                <Field title="申请日期" type='text' :text='Data.SQRQ' />
                <Field v-if="Data.SPLX==='5'" title="目的地" type='text' :text='Data.GOALINFO' />
                <Field title="申请原因" type='textarea' :text='Data.SQYY' :Isdisabled='true' />
            </div>
            <div v-if="this.Data.SPLX==='3'">
                <!--目前只有报废有图片展示-->
                <ImgModule upload v-if="uploadImg" :deletable="false" :disabled='true' :img="uploadImg" />
            </div>

            <div class="infoBox flowBox">
                <p class="title">审批流程</p>
                <ExamineModel :StepList="AuiitorList" />
            </div>
            <div class="infoBox ideaBox" v-if="this.$route.params.ExistsButton">
                <p class="title">审批意见</p>
                <Field title="审核人" type='text' :text='this.$UserInfo.UserName' />
                <Field title="审核时间" type='text' :text="this.$format(new Date(),'YYYY-MM-DD')" />
                <Field title="审核结果" placeholder="请选择" :tabSelected="ApplyResult" type="teb" :data="[{id:'1',name:'同意'},{id:'2',name:'否决'}]"
                    @onMessage="ApplyResult=arguments[0].id" />
                <Field title="审核意见" type='textarea' placeholder="请输入" @onMessage='value=>Remark=value' />
            </div>
        </Box>
        <div class="footer" v-if="this.$route.params.ExistsButton">
            <div class="button" @click="resolve">提交审核</div>
        </div>
    </div>
</template>

<script>
    import ImgModule from '../../components/imgModule/imgModule.vue'
    import Box from '../../components/commonBox/commonBox'
    import ExamineModel from '../../components/ExamineModel/ExamineModel'
    import Field from '../../components/field/field'
    import {
        ApplyResult
    } from '../../../tool/api/api.js'
    export default {
        name: 'SubscribeApply',
        data() {
            return {
                ChangeDeparment: {},
                uploadImg: [],
                Data: this.$route.params.item,
                Equipment: {},
                AuiitorList: [], //维修进程
                Remark: null,
                ApplyResult: '1',
                JCHH: null, //api请求后赋值
                JCBH: null, //api请求后赋值
                PageNmae: null, //分割后的名称
                TYPE: [{
                        id: '4',
                        name: 'ZKSH'
                    },
                    {
                        id: '3',
                        name: 'BFSH'
                    },
                    {
                        id: '5',
                        name: 'WDSH'
                    },
                    {
                        id: '2',
                        name: 'WXSH'
                    },
                    {
                        id: '1',
                        name: 'SBSH'
                    },
                    {
                        id: '6',
                        name: 'SBSH'
                    }
                ]
            }
        },
        mounted() {
            this.$scrollscreen('.commonBox','start');
            this.PageNmae = this.$route.params.item.TYPE.substring(0, 2);
            this.LoadPictureList();
        },
        components: {
            Box,
            ExamineModel,
            Field,
            ImgModule
        },
        methods: {
            resolve() { //提交审核
                const item = {
                    TYPE: this.TYPE.find(x => x.id === this.Data.SPLX).name,
                    SQDH: this.Data.SQDH,
                    SHR: this.$UserInfo.UserId,
                    SPLX: this.Data.SPLX,
                    SQR: '',
                    JCHH: this.Data.JCHH,
                    JCBH: this.Data.JCBH,
                    SHR: this.$UserInfo.UserId,
                    SHRQ: this.$format(new Date(), 'YYYY-MM-DD'),
                    SPYJ: this.Remark,
                    STORE: this.$UserInfo.StoreCode,
                    SBBH: this.Data.SBBH,
                    YJYY: this.Remark,
                    BFJY: this.Remark,
                    GKHM: this.$UserInfo.UserId,
                    SFTG: this.ApplyResult
                };
                ApplyResult(item);
            },
            LoadMaintainDefault() { //获取审批进程
                const that = this;
                that.$axios.all([that.$post('api/Audit/MultistageAuditProcess', { //1、加载当前审批流程      2、加载转科详情信息
                    SQDH: this.Data.SQDH,
                    SBBH: this.Data.SBBH?this.Data.SBBH:this.Data.SBMC,
                    SBMC: '',
                    SPLX: this.Data.SPLX,
                    TYPE: 'SBSH',
                    Token: '1234'
                }), that.LoadChangeDeparmentDefault()]).then(that.$axios.spread(function(result1, result2) {
                    for (let i = 0; i < result1.SPJCList.length; i++) {
                        that.AuiitorList.push({
                            AuditState: result1.SPJCList[i].JCMC,
                            UserCode: result1.SPJCList[i].SPR,
                            WaitDate: result1.SPJCList[i].SPSJ,
                            Remark: result1.SPJCList[i].SPYJ,
                            Result: result1.SPJCList[i].SPZT,
                        })
                    }
                    //处理第二个请求
                    try {
                        if (!result2) return false;
                        result2 = JSON.parse(result2);
                        if (result2.length != 0) that.ChangeDeparment = result2[0];
                    } catch (e) {
                        console.log(e);
                        that.$Toast('系统异常,请联系管理员!');
                        //TODO handle the exception
                    }
                }));
            },
            LoadPictureList() {
                if (this.Data.SPLX === '3') {
                    this.$get('api/Audit/GetApplyPicture', {
                        SBBH: this.Data.SBBH,
                        SQDH: this.Data.SQDH,
                        SPLX: this.Data.SPLX,
                    }).then(result => {
                        for (let i = 0; i < result.length; i++) {
                           result[i]?this.uploadImg.push({url: result[i]}):'';
                        }
                    })
                }
                this.LoadMaintainDefault()
            },
            LoadChangeDeparmentDefault() {
                return this.$route.params.item.SPLX === '4' ? this.$get('api/ZK/GetChangDeparmentDefault', {
                    SQDH: this.$route.params.item.SQDH
                }) : null;
            }
        },
    }
</script>

<style lang="scss" scoped>
    .accessoriesItems {
        margin-bottom: 20px;

        p {
            color: $TEXT-DARK-COLOR;
            font-size: 28px;
            margin-bottom: 14px;
        }

        div {
            color: #858585;
            font-size: 28px;
            display: flex;

            span {
                margin-right: 35px;

                &:last-child {
                    margin-right: 0;
                    font-size: 32px;
                    color: $TEXT-DARK-COLOR;
                    flex: 1;
                    text-align: right;
                    font-weight: bold;
                }
            }
        }
    }

    .maintainItems {
        display: flex;
        align-items: center;
        margin-bottom: 32px;

        span {
            &:first-child {
                font-size: 28px;
                color: #999;
                flex: 1;
            }

            &:last-child {
                font-size: 32px;
                color: $TEXT-DARK-COLOR;
                font-weight: bold;
            }
        }

        &:last-child {
            margin-bottom: 0;
        }
    }

    .flowBox {
        .title {
            margin-bottom: 50px;
        }
    }

    .ideaBox {

        textarea {
            font-size: 30px;
            width: 100%;
            border: none;
            resize: none;

            &::-webkit-input-placeholder {
                color: #858585;
            }
        }
    }

    .footer {
        position: fixed;
        bottom: 0;
        width: 100%;
        height: 114px;
        background: $BACKGROUND-COLOR;
        box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.16);
        padding-top: 24px;

        .button {
            width: 690px;
            height: 96px;
            background: $THEME-COLOR;
            border-radius: 8px;
            color: $TEXT-LIGHT-COLOR;
            font-size: 30px;
            text-align: center;
            line-height: 96px;
            margin: auto;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/Apply/subscribeApply.vue